import type { TransactionInfosP2PType } from '~/types';

export const useWalletNavigation = () => {
  const { $i18n } = useNuxtApp();
  const { t, locale } = $i18n;

  const getCellDate = (date?: string) => {
    if (!date) return;
    return getFormattedDate(getDate(date), 'L LT', locale.value);
  };

  const canRedirectToMoneyOut = (moneyOutId?: number) =>
    checkPermission('manageOperations') && moneyOutId;

  const canRedirectToTransaction = (type: 0 | 1 | 2) =>
    [0, 1, 2].includes(type) && checkPermission('manageOperations');

  const canRedirectToUsers = (type: 0 | 1) =>
    [0, 1].includes(type) && checkPermission('manageBoUsers');

  const handleRedirectToUsers = (userId: number) => {
    navigateTo({ name: 'users', params: { id: userId } });
  };

  const canRedirectToRoles = (type: 0 | 1) =>
    [0, 1].includes(type) && checkPermission('gestionAccesBo');

  const handleRedirectToRoles = (roleId: number) => {
    navigateTo({ name: 'roles', params: { id: roleId } });
  };

  const handleRedicrectToTransaction = (transactionId: number) => {
    navigateTo({
      name: 'partner-transactions-id-tab',
      params: { id: transactionId, tab: 'details' }
    });
  };

  const hasSenderOrReceiver = (type: string, transaction: TransactionInfosP2PType) =>
    type === 'sender'
      ? transaction.senderFirstName && transaction.senderLastName
      : transaction.receiverFirstName && transaction.receiverLastName;

  const handleEntityUser = (userMail: string) => {
    if (userMail.toLowerCase() === 'lemonway') {
      return {
        hasIcon: true,
        isCircle: true,
        subtitles: [],
        icon: 'Lemonway',
        title: 'Lemonway',
        theme: 'success'
      };
    }
    return {
      hasIcon: true,
      isCircle: true,
      subtitles: [userMail],
      title: t('common.user'),
      icon: 'Person',
      theme: 'warning'
    };
  };

  return {
    getCellDate,
    canRedirectToMoneyOut,
    canRedirectToTransaction,
    canRedirectToUsers,
    handleRedirectToUsers,
    canRedirectToRoles,
    handleRedirectToRoles,
    handleRedicrectToTransaction,
    hasSenderOrReceiver,
    handleEntityUser
  };
};
